// import { vueVimeoPlayer } from 'vue-vimeo-player';
import vimeoTech from './vimeo-tech';
import Player from '@vimeo/player';
import axios from 'axios';
import swal from 'sweetalert';
export default {
    // components: {
    //     vueVimeoPlayer,
    // },

    props: {
        dataVideo: {
            type: Object,
            required: true
        },
        dataShowInfo: {
            type: Boolean,
            default: true
        },
        dataHasInPlaylist: {
            type: Boolean,
            default: false
        },
        isPlaylist: {
            type: Boolean,
            default: false
        },
        loopPlaylist: {
            type: Boolean,
            default: false
        },
        vimeoAvailable: {
            type: Boolean,
            default: false
        },
    },

    computed: {
        playerStyles() {

        },
        page() {
            const params = new Proxy(new URLSearchParams(window.location.search), {
                get: (searchParams, prop) => searchParams.get(prop),
            });
            return params.page ? parseInt(params.page) : 1;
        },
        cc() {
            const params = new Proxy(new URLSearchParams(window.location.search), {
                get: (searchParams, prop) => searchParams.get(prop),
            });
            return params.cc && params.cc == 'true' ? true : false;
        }
    },

    data() {
        return {
            video: this.dataVideo,
            showInfo: this.dataShowInfo,
            hasInPlaylist: this.dataHasInPlaylist,
            player: null,
            playerWidth: 600,
            isFullScreen: JSON.parse(localStorage.getItem('is_fullscreen')) || false,
        };
    },

    mounted() {
        this.adjustPlayerWidth();

        if (!this.showInfo) {
            this.initPlayer();
        }

        if (this.isPlaylist) {
            this.attachEndedEvent();
        }
    },

    methods: {
        adjustPlayerWidth() {
            const containerWidth = this.$refs['container'].offsetWidth;
            this.playerWidth = containerWidth > 600 ? 600 : containerWidth - 20;
        },

        initPlayer() {
            if (this.player) {
                this.player.play();
                return;
            }
            this.makePlayer();
        },
        makePlayer() {
            // const options = {
            //     autoplay: true,
            //     techOrder: [],
            //     sources: [],
            //     width: this.playerWidth,
            //     // fluid: this.video.video_type !== 'flv'
            // };

            // if (this.vimeoAvailable) {
            //     options.techOrder.push('vimeo');
            //     options.sources.push({ type: 'video/vimeo', src: `https://vimeo.com/${this.video.vimeo_code}` });
            // }

            // if (this.video.video_public_path) {
            //     options.controls = ! this.vimeoAvailable;
            //     options.techOrder.push('html5');
            //     options.sources.push({ type: `video/${this.video.video_type}`, src: this.video.video_public_path });

            //     if (this.video.video_type === 'flv') {
            //         options.techOrder.push('flash');
            //     }
            // }

            // document.getElementById("player").classList.add('video-js');
            // this.player = videojs(document.getElementById("player"), options);

            // this.player.on('pause', () => {
            //     // console.log('on pause event');
            // });

            // this.player.on('play', () => {
            //     // console.log('on play event');
            // });

            // if (this.isPlaylist) {
            //     this.player.on('ended', () => {
            //         this.goToNext();
            //     });
            // }
            const options = {
                id: this.video.vimeo_code,
                width: this.playerWidth,
                loop: false,
                title: false,
                byline: false,
                portrait: false,
                autoplay: true,
                texttrack: this.cc ? 'en-x-autogen' : '',
            };

            this.player = new Player('video-player', options);

            if (this.isPlaylist) {
                this.player.on('ended', () => {
                    this.goToNext();
                });
            }

        },

        destroyPlayer() {
            // pause the video
            this.player.pause();
        },

        addToPlaylist() {
            if (this.hasInPlaylist) {
                return this.removeFromPlaylist();
            }

            this.postRequest('/playlist/add', { title_id: this.video.id })
                .then(data => {
                    if (data.results && data.results.added) {
                        this.hasInPlaylist = true;
                    }
                })
                .catch(error => {
                    showResponse('There was an unexpected error', 'error');
                });
        },

        removeFromPlaylist() {
            if (!this.hasInPlaylist) {
                return this.addToPlaylist();
            }

            this.postRequest('/playlist/remove', { title_id: this.video.id })
                .then(data => {
                    if (data.results && data.results.removed) {
                        this.hasInPlaylist = false;
                    }
                })
                .catch(error => {
                    showResponse('There was an unexpected error', 'error');
                });
        },

        toggleInPlaylist() {
            this.hasInPlaylist ? this.removeFromPlaylist() : this.addToPlaylist();
        },

        attachEndedEvent() {
            if (this.video.vimeo_code === null) {
                if (this.video.video_type !== 'swf') {
                    try {
                        const player = document.getElementsByTagName('video')[0];

                        player.onended = () => {
                            this.goToNext();
                        }
                    } catch (e) {}
                }
            }
        },

        goToNext(page = null) {
            const params = new Proxy(new URLSearchParams(window.location.search), {
                get: (searchParams, prop) => searchParams.get(prop),
            });
            var page = page ? page : (params.page ? parseInt(params.page) + 1 : 2);
            axios.get('/playlist/play', {
                params: {
                    page: page,
                }
            }).then(response => {
                if (response.data.title) {
                    var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + "?page=" + page + "&loop=" + (params.loop ? params.loop : 0) + "&category=" + (params.category ? params.category : '') + "&cc=" + (params.cc ? params.cc : '');
                    window.history.pushState({ path: newurl }, '', newurl);
                    if (page > 1) {
                        var prevurl = window.location.protocol + "//" + window.location.host + window.location.pathname + "?page=" + (page - 1 > 0 ? page - 1 : 1) + "&loop=" + (params.loop ? params.loop : 0) + "&category=" + (params.category ? params.category : '') + "&cc=" + (params.cc ? params.cc : '');
                        $('#previousPage').show().attr('href', prevurl);
                    } else {
                        $('#previousPage').hide()
                    }
                    if (response.data.has_more) {
                        var nexturl = window.location.protocol + "//" + window.location.host + window.location.pathname + "?page=" + (page + 1) + "&loop=" + (params.loop ? params.loop : 0) + "&category=" + (params.category ? params.category : '') + "&cc=" + (params.cc ? params.cc : '');
                        $('#nextPage').show().attr('href', nexturl);
                    } else {
                        $('#nextPage').hide();
                    }
                    this.video = response.data.title;
                    this.player.loadVideo(this.video.vimeo_code).then(resp => {
                        this.player.play();
                        if (this.cc) {
                            this.player.enableTextTrack('en-x-autogen').catch(error => {
                                
                            });
                        }
                    });
                } else {
                    if (!response.data.has_more && this.loopPlaylist) {
                        this.goToNext(1);
                    }
                }
                return response;
            }).catch(error => {
                console.log(error);
                alert('An error has occurred');
            })
        },
        async createShareLink() {
            await axios.post(`/videos/${ this.video.id }/share`)
                .then(response => {
                    var div = document.createElement('div');
                    div.innerHTML = `<p style="word-wrap: break-word;">Use the following URL to share this video: <a href="${ response.data.url }" target="_blank">${ response.data.url }</a>`;
                    return swal({
                        title: 'Share Link',
                        content: div,
                        buttons: {
                            cancel: 'Close',
                            copy: 'Copy Link',
                        }
                    }).then(res => {
                        if (res) {
                            try {
                                navigator.clipboard.writeText(response.data.url);
                            } catch (err) {
                                alert('Failed to copy. Please manually copy link.');
                            }
                        }
                        return res;
                    });
                }).catch(error => {
                    alert('An error has occurred trying to get the share link. Please try again later');
                    return error;
                });
        },
    },

    watch: {
        showInfo(newValue, oldValue) {
            if (newValue !== oldValue) {
                if (newValue === false) {
                    this.$nextTick(() => {
                        this.initPlayer();
                    });
                } else {
                    this.destroyPlayer();
                }
            }
        }
    }
};